import React from 'react';

import { Button } from '..';
import { useForm } from '../Form';
import type { ButtonProps } from '../Button';

const SubmitButton: React.FC<ButtonProps> = ({ disabled, ...rest }) => {
  const { canSubmit } = useForm();

  return <Button {...rest} disabled={!canSubmit || disabled} />;
};

export default React.memo(SubmitButton) as typeof SubmitButton;
